import {connect} from 'react-redux';
import {actions, Form, } from 'forms/rrf';
import {Col, Row} from 'react-bootstrap';
import RequiredInput from '../../../../common/form/elements/required-input';
import ImageUpload from '../../../../common/form/elements/image-upload';
import ArrowButton from '../../../../common/button-arrow';
import {saveCategory, updateCategory} from '../../../../../actions/categories';

const EditCategoryForm = ({dispatch, category, formValid}) => {
  const onSubmit = (payLoad) => {
    if (category.id) {
      dispatch(actions.submitFields('deep.admin_category', updateCategory(category.id, payLoad)));
    } else {
      dispatch(actions.submitFields('deep.admin_category', saveCategory(payLoad)));
    }
  };

  let image;

  if (category) {
    const {attributes} = category;
    image = attributes.links ? attributes.links.photo : undefined;
  }

  return (
    <Form model="deep.admin_category" onSubmit={onSubmit}>
      <Row>
        <Col lg={12}>
          <RequiredInput
            controlId='name'
            label="Name"
            model='.name'
            placeholder="Name"
          />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ImageUpload
            model=".photo"
            required
            sizeLimit={1024 * 1024}
            source={image}
            type={['image/png', 'image/jpg', 'image/jpeg']}
          />
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          <ArrowButton
            className="float-end"
            color="grey"
            disabled={!formValid}
          >
            Save
          </ArrowButton>
        </Col>
      </Row>
    </Form>
  );
};

const mapStateToProps = state => ({
  formValid: state.deep.forms.admin_category.$form.valid
});

export default connect(mapStateToProps)(EditCategoryForm);
